export class IncentiveControllerAdminApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** The market's mode and governed policy, the shadow period and the kills (`incentive_lever:view`). */
    state(marketId) {
        return this.client.request({ method: 'GET', path: `/v1/admin/incentive-controller?${new URLSearchParams({ market: marketId }).toString()}`, auth: true });
    }
    /** The append-only log of every evaluation, newest first (`incentive_lever:view`). */
    decisions(marketId, filter = {}) {
        const q = new URLSearchParams({ market: marketId });
        for (const [k, v] of Object.entries(filter))
            if (v !== undefined)
                q.set(k, String(v));
        return this.client.request({ method: 'GET', path: `/v1/admin/incentive-controller/decisions?${q.toString()}`, auth: true });
    }
    /** The trail of one kill (`incentive_lever:view`). */
    killEvents(marketId, killId) {
        return this.client.request({ method: 'GET', path: `/v1/admin/incentive-controller/kills/${encodeURIComponent(killId)}/events?${new URLSearchParams({ market: marketId }).toString()}`, auth: true });
    }
    /** KILL (`incentive_lever:manage`): ONE operator, immediate; the controller's live rows end at once. A COUNTRY kill needs country-level authority (403 otherwise). */
    kill(input) {
        return this.client.request({ method: 'POST', path: '/v1/admin/incentive-controller/kills', body: input, auth: true });
    }
    /** PROPOSE lifting a kill (the maker, `incentive_lever:manage`). */
    proposeReenable(killId, input) {
        return this.client.request({ method: 'POST', path: `/v1/admin/incentive-controller/kills/${encodeURIComponent(killId)}/reenable`, body: input, auth: true });
    }
    /** FOUR EYES: a DIFFERENT operator (`incentive_lever:approve`) approves (the kill is LIFTED) or refuses (back to KILLED); `403 KILL_SELF_APPROVAL` for the proposer. */
    decideReenable(killId, input) {
        return this.client.request({ method: 'POST', path: `/v1/admin/incentive-controller/kills/${encodeURIComponent(killId)}/decision`, body: input, auth: true });
    }
}
//# sourceMappingURL=incentive-controller.js.map